export default __webpack_public_path__ + "static/media/secured.08a8d53b.png";